import React, { useEffect, useState } from "react";
import { BsCheckCircleFill, BsChevronDown, BsChevronUp } from "react-icons/bs";
import styles from "./dropdown.module.css";

const Dropdown = ({
  options,
  name,
  label,
  onChange,
  className,
  placeholder,
  selectedValue,
  labelClass,
  stylesClass,
  contClass,
  stylesClasss,
  object,
  selectedClass,
  style,
  setActiveIndex,
}) => {
  const [active, setActive] = useState(selectedValue);
  const [activIendex, setActivIendex] = useState(
    selectedValue ? object?.findIndex((item) => selectedValue == item.name) : -1
  );
  const [open, setOpen] = useState(false);
  const handleChange = (value) => {
    setActive(value.val ? value.val : value);
    setOpen(!open);
    onChange(value);
  };

  useEffect(() => {
    setActive(selectedValue);
  }, [selectedValue]);

  console.log("activIendex", object);

  const objectOptions =
    object &&
    object.map((cur) => ({
      ["Value"]: cur.name && cur.name,
      ["option"]: cur.name && cur.name,
      ["Id"]: cur.id && cur.id,
    }));

  return (
    <div className={`${styles.mainCon} ${stylesClass}`} style={style}>
      {label ? (
        <label className={`${styles.label} ${labelClass}`}>{label}</label>
      ) : null}
      <div className={`${styles.dropdownStyle} ${stylesClasss}`}>
        <div className={styles.mainDropdownDiv} onClick={() => setOpen(!open)}>
          {active ? (
            <label className={`${styles.selected} ${selectedClass}`}>
              {active}
            </label>
          ) : (
            <label className={styles.placeholder}>{placeholder}</label>
          )}
          {open ? <BsChevronUp size={20} /> : <BsChevronDown size={20} />}
        </div>
      </div>

      {options?.length > 0 ? (
        <div
          className={
            open ? `${styles.optionDiv} ${contClass}` : styles.displayNone
          }
          style={!label ? { top: "20px", marginTop: "0px" } : {}}
        >
          {options?.map((data, i) => (
            <div className={styles.option} key={i}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "5px",
                  alignItems: "center",
                }}
                onClick={() => {
                  setActivIendex(i);
                  handleChange(data.option);
                }}
              >
                <div>
                  <BsCheckCircleFill
                    size={20}
                    className={styles.icon}
                    color={
                      activIendex == i ? "var(--primary-color)" : "#BEBEBE"
                    }
                  />
                </div>
                <span className={styles.optionText}>{data.option}</span>
              </div>
            </div>
          ))}
        </div>
      ) : objectOptions?.length > 0 ? (
        <div
          className={
            open ? `${styles.optionDiv} ${contClass}` : styles.displayNone
          }
          style={!label ? { top: "20px", marginTop: "0px" } : {}}
        >
          {objectOptions?.map(
            (
              data,
              i // For dynamic arrays.
            ) => (
              <div className={styles.option} key={i}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "5px",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    setActivIendex(i);
                    handleChange({ val: data.option, id: data.Id });
                  }} //Returns Value and ID.
                >
                  <div>
                    <BsCheckCircleFill
                      size={20}
                      className={styles.icon}
                      color={
                        activIendex == i ? "var(--primary-color)" : "#BEBEBE"
                      }
                    />
                  </div>
                  <span className={styles.optionText}>{data.option}</span>
                </div>
              </div>
            )
          )}
        </div>
      ) : (
        <div
          className={
            open ? `${styles.optionDiv} ${contClass}` : styles.displayNone
          }
          style={!label ? { top: "20px", marginTop: "0px" } : {}}
        >
          <div className={styles.option}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                margin: "5px",
                alignItems: "center",
              }}
            >
              {/* <div>
              <BsCheckCircleFill
                size={20}
                className={styles.icon}
                color={activIendex == i ? "var(--primary-color)" : "#BEBEBE"}
              />
            </div> */}
              <span className={styles.optionText}>No Options Found</span>
            </div>
          </div>
        </div>
      )}
    </div>
    // </Form.Item>
  );
};

export default Dropdown;
